import React, { useEffect } from 'react';
import { Navigation } from '../components/Navigation';
import { Hero } from '../components/Hero';
import { ActivitySection } from '../components/ActivitySection';
import { SocialImpactSection } from '../components/SocialImpactSection';
import { ContactSection } from '../components/ContactSection';
import { Footer } from '../components/Footer';
export function BeachClubPage() {
  // Set RTL direction for the entire page
  useEffect(() => {
    document.documentElement.dir = 'rtl';
    document.documentElement.lang = 'he';
    return () => {
      document.documentElement.dir = 'ltr';
      document.documentElement.lang = 'en';
    };
  }, []);
  return <div className="min-h-screen bg-white font-sans text-right" dir="rtl" data-id="element-238">
      <Navigation data-id="element-239" />
      <main data-id="element-240">
        <Hero data-id="element-241" />
        <ActivitySection data-id="element-242" />
        <SocialImpactSection data-id="element-243" />
        <ContactSection data-id="element-244" />
      </main>
      <Footer data-id="element-245" />
    </div>;
}